export enum TicketPriority {
  Urgent = 'urgent',
  Normal = 'normal',
}
